module.exports = __webpack_public_path__ + "img/康和达.5562c525.png";